import { createWebHistory, createRouter } from 'vue-router'
import Layout from '@/layout'

/**
 * Note: 路由配置项
 *
 * hidden: true                     // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true                 // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                  // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                  // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                  // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect             // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'               // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * query: '{"id": 1, "name": "ry"}' // 访问路由的默认传递参数
 * meta : {
    noCache: true                   // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'                  // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'                // 设置该路由的图标，对应路径src/assets/icons/svg
    breadcrumb: false               // 如果设置为false，则不会在breadcrumb面包屑中显示
    activeMenu: '/system/user'      // 当路由设置了该属性，则会高亮相对应的侧边栏。
  }
 */

// 公共路由
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index.vue')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
  },
  {
    path: '/user/center/modify',
    component: () => import('@/views/user/center/modify'),
    hidden: true
  },
  {
    path: '/verification/index',
    component: () => import('@/views/verification/index'),
    hidden: true
  },
  {
    path: '',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: '/index',
        component: () => import('@/views/index'),
        name: 'Index',
        meta: { title: '控制台', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/user',
    redirect: '/user/center/index',
    component: Layout,
    meta: { title: '个人中心', icon: 'my' },
    hidden: true,//隐藏该菜单
    children: [
      {
        path: '/user/center/index',
        name: 'UserCenter',
        component: () => import('@/views/user/center/index'),
        meta: { title: '管理员信息', icon: 'card' }
      },{
        path: '/app/pages/design/:id/:code',
        name: 'DesignCenter',
        component: () => import('@/views/app/pages/design'),
        meta: { title: '页面设计', icon: 'card' }
      }
    ]
  },
  {
    path: '/test',
    redirect: '/test/index',
    component: Layout,
    meta: { title: '测试中心', icon: 'my' },
    hidden: true,//隐藏该菜单
    children: [
      {
        path: '/test/index',
        name: 'testCenter',
        component: () => import('@/views/test/index'),
        meta: { title: '测试信息', icon: 'card' }
      }
    ]
  },
  {
    path: '/401',
    component: () => import('@/views/error/401'),
    hidden: true
  },
  {
    // 如果域名后面什么都不写或者没有和已经定义好的路由匹配的话
    path: "/:pathMatch(.*)*",
    component: () => import('@/views/error/404'),
    hidden: true
  }
];
// 注意注意！！添加404页面一定要在所有路由后面喔
const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
});

export default router;
